var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFullIconSmall = function SvgFullIconSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_52",
    "data-name": "Group 52",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.002,
    height: 18.001,
    viewBox: "0 0 32.002 18.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Box",
    "data-name": "White Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M651.033,516.218h-31v-17h31Z",
    transform: "translate(-619.531 -498.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M620.531,499.717v16h30v-16h-30m-1-1h32v18h-32Z",
    transform: "translate(-619.531 -498.717)",
    fill: "#024"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box",
    "data-name": "Grey Box",
    d: "M621.531,500.716h28v14h-28Z",
    transform: "translate(-619.531 -498.717)",
    fill: "#024"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullIconSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "full-icon-small.d2083e57171d987dd74b28f83c09db27.svg";